import { Library, Loader } from '@googlemaps/js-api-loader';

import { GOOGLE_MAPS_API_KEY } from '@/utils/keys';
import { getBrowserLanguage, Language } from '@/utils/languages';

export interface GoogleMapsLoader {
  importLibrary(name: 'places'): Promise<google.maps.PlacesLibrary>;
}

export function installGoogleMaps(): GoogleMapsLoader {
  return new Loader(getOptions(getBrowserLanguage()));
}

function getOptions(language: Language) {
  return {
    apiKey: GOOGLE_MAPS_API_KEY,
    version: 'weekly',
    libraries: ['places'] as Library[],
    region: language.toUpperCase(),
    language,
  };
}
